import React from 'react';
import { Alert } from '../../Alert';
import { AsyncButton } from '../../Button';
import { useTimezoneWarning } from './use-timezone-warning.hook';

export const TimezoneWarning: React.VFC = () => {
  const { isActive, confirm } = useTimezoneWarning();

  if (!isActive) return null;

  return (
    <Alert showIcon={false} title="Confirm your session timezone" severity="warning">
      We'll show available session times in Arizona Time. Arizona does not observe Daylight Saving Time, so this may differ from Mountain Time during part of the year.

      <AsyncButton
        variant="contained" size="small" color="secondary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={confirm}
      >
        Confirm Arizona Time
      </AsyncButton>
    </Alert>
  );
};
